import { render, staticRenderFns } from "./uppy_cars_doc.vue?vue&type=template&id=581b382d&scoped=true"
import script from "./uppy_cars_doc.vue?vue&type=script&lang=js"
export * from "./uppy_cars_doc.vue?vue&type=script&lang=js"
import style0 from "./uppy_cars_doc.vue?vue&type=style&index=0&id=581b382d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b382d",
  null
  
)

export default component.exports